import * as types from '../actionTypes/candidate'

let defaultState = {
  candidates: [],
  candidateListItems: [],
  currentCandidate: {},
  rejectReason: {},
}

const candidateReducer = (state = defaultState, action) => {
  if (action.type === types.GET_CANDIDATES) {
    return {
      ...state,
      candidates: action.candidates
    }
  }
  else if (action.type === types.GET_CANDIDATE_LIST_ITEMS) {
    return {
      ...state,
      candidateListItems: action.candidateListItems
    }
  }
  else if (action.type === types.GET_CANDIDATE) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.candidate) {
      action.candidate = {}
    } else {
      action.candidate = {
        ...action.candidate,
        // convert dates into date objects before putting into store so they can be treated properly without needing to convert later
        DateOfBirth: action.candidate.DateOfBirth ? new Date(action.candidate.DateOfBirth) : null,
      }
    }

    return {
      ...state,
      currentCandidate: action.candidate
    }
  }
  else if (action.type === types.GET_REJECT_REASON) {
    return {
      ...state,
      rejectReason: action.rejectReason
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default candidateReducer;


// WEBPACK FOOTER //
// ./src/reducers/candidate.js